import React, { createContext, useState } from 'react'
import Header from '../../common/Header'
import { makeStyles } from '@mui/styles'
import BackGroundImage from '../../../assets/image/desktop-background/bg-03.png'
import MobileBackGroundImage from '../../../assets/image/mobile-background/mobile-bg-02.jpg'
// import ChatBox from '../../common/ChatBox'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
import StepFour from './StepFour'
import MultiStepProgressBar from './MultiStepProgressBar'

export const Context = createContext({ setState: () => { } });

const useStyles = makeStyles((theme) => ({
    body: {
        backgroundImage: `url(${BackGroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        height: '100%',
        minHeight: '100vh',
        width: '100vw',
    },
    text: {
        height: "auto",
        width: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
    },
    //back button design
    backbutton: {
        height: 'fit-content',
        padding: '0 20px',
        display: 'flex',
        alignItems: 'center',
        columnGap: '10px',
        marginTop: '1.250rem',
        '& p': {
            color: '#FF4F21'
        }
    },
    pointer: {
        cursor: 'pointer'
    },

    '@media (max-width: 1000px)': {
        body: {
            backgroundImage: `url(${MobileBackGroundImage})`,
            width: "100%",
            minHeight: "100vh",
            height: '100%'
        },
        backbutton: {
            marginTop: '0',
            columnGap: '5px',
            padding: '0 10px',
        },
        text: {
            width: '100vw'
        },

    }
}))

function StepZero() {

    const classes = useStyles()

    const [stepOne, setStepOne] = useState(true)
    const [stepTwo, setStepTwo] = useState(false)
    const [stepThree, setStepThree] = useState(false)
    const [stepFour, setStepFour] = useState(false)

    const [state, setState] = useState({});

    const [page, setPage] = useState("pageone");

    const nextPage = (page) => {
        setPage(page);
    };

    return (
        <Context.Provider value={{ state, setState }}>
            <div className={classes.body}>
                {!stepOne && <Header />}

                <div className={classes.text}>

                    {/* ProgressBar */}
                    {stepTwo && <MultiStepProgressBar page={page} step="STEP 2" />}
                    {stepThree && <MultiStepProgressBar page={page} step="STEP 3" />}
                    {stepFour && <MultiStepProgressBar page={page} step="STEP 4" />}

                    {/* step 01 */}
                    {stepOne && <StepOne
                        setStepTwo={setStepTwo}
                        onButtonClick={nextPage}
                        setStepOne={setStepOne} />}

                    {/* step 02 */}
                    {stepTwo && <StepTwo
                        setStepOne={setStepOne}
                        setStepThree={setStepThree}
                        onButtonClick={nextPage}
                        setStepTwo={setStepTwo}
                    />}

                    {/* step 03 */}
                    {stepThree && <StepThree
                        setStepTwo={setStepTwo}
                        onButtonClick={nextPage}
                        setStepThree={setStepThree}
                        setStepFour={setStepFour}
                    />}

                    {/* step 04 */}
                    {stepFour && <StepFour
                        setStepThree={setStepThree}
                        setStepFour={setStepFour} />}

                </div>
                {/*<ChatIcon />*/}
            </div>
        </Context.Provider>
    )
}

export default StepZero


